module.exports = __webpack_public_path__ + "img/symbol_6.cc43a336.png";